<template>
	<ContestOfferSummaryBidderDetails :title="title" :bidder-data="bidderData"/>
</template>

<script>
	import {Bidder} from "@/api/generated/Bidder";
  import ContestOfferSummaryBidderDetails from "@/view/logged/offer/components/ContestOfferSummaryBidderDetails";

	export default {
		name: "ContestOfferSummaryBidderDetailsView",
    components: {ContestOfferSummaryBidderDetails},

    props: {
			title: String,
			bidderId: Number,
      offerId: String,
      projectId: String,
		},

		data() {
			return {
				bidderData: {},
			};
		},

    mounted() {
      if (this.offerId) {
        this.getBidderDetailsByOfferId();
      } else if (this.projectId) {
        this.getBidderDetailsByProjectId();
      }
    },

		methods: {
      bidderDetailsRequestSuccessHandler() {
        return (successResponse) => {
          this.bidderData = successResponse;
        };
      },

      bidderDetailsRequestErrorHandler() {
        return (errorResponse) => {
          this.$messagesBus.$emit("error", "Nie udało się załadować danych oferenta", errorResponse);
        };
      },

      getBidderDetailsByOfferId() {
        if (this.$route.params.version) {
          Bidder.getOriginalOfferVersionDetails(this, this.bidderId, this.offerId, this.$route.params.version,
              this.bidderDetailsRequestSuccessHandler(), this.bidderDetailsRequestErrorHandler());
        } else {
          Bidder.getOriginalOfferDetails(this, this.bidderId, this.offerId,
              this.bidderDetailsRequestSuccessHandler(), this.bidderDetailsRequestErrorHandler());
        }
      },

      getBidderDetailsByProjectId() {
        if (this.$route.params.version) {
          Bidder.getOriginalProjectVersionDetails(this, this.bidderId, this.projectId, this.$route.params.version,
              this.bidderDetailsRequestSuccessHandler(), this.bidderDetailsRequestErrorHandler());
        } else {
          Bidder.getOriginalProjectDetails(this, this.bidderId, this.projectId,
              this.bidderDetailsRequestSuccessHandler(), this.bidderDetailsRequestErrorHandler());
        }
      }
		},
	};
</script>

<style scoped>

</style>
